<section class="hero-row">
  <article class="weather-card">
    <div class="weather-art" aria-hidden="true">
      @if (meteo(); as m) {
        <span class="material-symbols-outlined weather-art-icon" [style.color]="m.couleur">{{ m.icone }}</span>
      } @else {
        <span class="cloud cloud-one"></span>
        <span class="cloud cloud-two"></span>
        <span class="rain rain-one"></span>
        <span class="rain rain-two"></span>
        <span class="rain rain-three"></span>
      }
    </div>
    <div class="weather-copy">
      <span class="date-label">{{ dateLabel }}</span>
      <p>{{ nomParc() }}</p>
      @if (meteo(); as m) {
        <strong>{{ m.temperature }}&deg;C</strong>
      } @else {
        <strong>—</strong>
      }
    </div>
  </article>

  <div class="metric-grid">
    <article class="metric-card">
      <span class="metric-title">Puissance moy.</span>
      <strong>{{ puissanceMoyenne() | puissanceUnite }}</strong>
    </article>
    <article class="metric-card">
      <span class="metric-title">Energie cumulee</span>
      <strong>{{ energieCumulee() | energieUnite }}</strong>
    </article>
    <article class="metric-card">
      <span class="metric-title">CO2 evite</span>
      <strong>{{ co2evite() | co2Unite }}</strong>
    </article>
    <article class="metric-card">
      <span class="metric-title">Gains cumules</span>
      <strong>{{ gainsCumules() | deviseUnite }}</strong>
    </article>
  </div>
  @if (erreur()) { <p role="alert">{{ erreur() }}</p> }
  <app-spinner-overlay [visible]="chargement()" label="Chargement..." />
</section>
